// @ts-nocheck
import isArguments from "lodash/isArguments";
import isArray from "lodash/isArray";
import isPlainObject from "lodash/isPlainObject";

const cleanupObject = (data: any) => {
    if (isPlainObject(data) || isArguments(data) || isArray(data)) {
        Object.entries(data).forEach(([key, value]) => {
            if (typeof value === "undefined") {
                delete data[key];
            } else {
                cleanupObject(value);
            }
        });
    }
};

export default cleanupObject;
